import { useSelector } from "react-redux";
import Switch from "../ui/Switch";

function CardObject({ checkedList, changeHandler, all, allHandler }) {
    //checkedList = [1,2]

    const stateSize = useSelector((state) => state.size);//Размеры окна

    return (
        <div>
            <Switch name="Все объекты" description="" checked={all} handleChange={(val) => allHandler(val)} />
            {all === false && (
                <>
                    <Switch name="Задача" id_item={1} checked={checkedList.filter(a => a == 1).length > 0 ? true : false} handleChange={changeHandler} />
                    <Switch name="Переодическая задача" id_item={2} checked={checkedList.filter(a => a == 2).length > 0 ? true : false} handleChange={changeHandler} />
                    <Switch name="Доска" id_item={3} checked={checkedList.filter(a => a == 3).length > 0 ? true : false} handleChange={changeHandler} />
                </>
            )}
        </div>
    )
}

export default CardObject;